var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAchraRounded = function SvgAchraRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#7A3AFF",
    fillOpacity: 0.3,
    rx: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7A3AFF",
    fillRule: "evenodd",
    clipPath: "url(#achra-rounded_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.91 14.27a8.03 8.03 0 0 1 5.733 2.383q.558.562.985 1.2a.41.41 0 0 1-.19.602l-2.464 1.04a.45.45 0 0 1-.52-.132 4.645 4.645 0 0 0-1.378-1.104 4.6 4.6 0 0 0-2.166-.529 4.62 4.62 0 0 0-3.545 1.633.45.45 0 0 1-.52.133l-2.464-1.04a.41.41 0 0 1-.19-.604q.427-.636.985-1.2a8.03 8.03 0 0 1 5.734-2.383M7.726 6.567a4.68 4.68 0 0 1-2.98 4.367.45.45 0 0 0-.294.383l-.215 2.781a.407.407 0 0 0 .482.44c3.679-.763 6.445-4.042 6.445-7.971 0-.612-.067-1.209-.194-1.782a.408.408 0 0 0-.56-.282L7.962 5.505a.456.456 0 0 0-.27.482q.035.285.035.58M16.274 6.567a4.68 4.68 0 0 0 2.98 4.367c.162.063.28.21.294.383l.216 2.781a.407.407 0 0 1-.482.44c-3.68-.763-6.446-4.042-6.446-7.971 0-.612.067-1.209.195-1.782a.408.408 0 0 1 .559-.282l2.45 1.002c.189.077.294.278.27.482q-.036.285-.036.58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "achra-rounded_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h16v16H4z"
  })))));
};
export default SvgAchraRounded;